import angular from 'angular'

import displayModule from './display/display.module'
import generalModule from './general/general.module'

import settingRoutes from './setting.routes'
import settingMenu from './setting.menu'
import settingRun from './setting.run'

const name = 'routingSetting'

angular.module(name, [
  displayModule,
  generalModule,
])
  .config(settingRoutes)
  .run(settingRun)
  .factory('settingMenu', settingMenu)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/setting/setting.module.js